// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"fb0bffecfa15cc738998","678":"abb05b92bf55f776132e","731":"af2369971012a1cc70e2","843":"6b2768d43fcfd44881ba","883":"e46bbfc1edd6c3beed87"}[chunkId] + ".js";
};